import React from 'react'

const Footer = () => {
  return (
    <>
    {/* Footer Area */}
    <footer id="footer" className="footer ">
      {/* Footer Top */}
      <div className="footer-top" style={{ paddingBottom: 20 }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="single-footer text-center">
                {/* Social */}
                <ul className="social" style={{ padding: "20px 0px" }}>
                  <li>
                    <a  href="#top">
                      <i className="icofont-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-google-plus" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-vimeo" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-pinterest" />
                    </a>
                  </li>
                </ul>
                {/* End Social */}
                <div className="copyright-content">
                  <p>
                    © Copyright 2023 | All Rights Reserved by{" "}
                    <a href="" target="_blank">
                      www.witcare.com
                    </a>{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*/ End Footer Top */}
      {/*/ End Copyright */}
    </footer>
    </>
  )
}

export default Footer